<template>
  <div class="about">
    <!-- 展会计划 -->
    <!-- <template v-if="planList && planList.length > 0">
      <div class="about-list" v-for="(item,index) in planList" :key="index" @click="link(item)">
        <img v-if="item.cover" :src="item.cover" />
        <div class="list-text">
          <div>
            <h3 :title="item.name">{{item.name}}</h3>
            <p class="t">时间：{{item.time}}</p>
            <p class="t">地点：{{item.address}}</p>
            <p>展会简介：</p>
            <p v-if="item.description" :title="item.description">{{item.description.length > 100?item.description.slice(0,100) + "...":item.description}}</p>
          </div>
        </div>
      </div>
    </template>
    <div v-else style="line-height:500px;text-align:center;">
      暂无数据！
    </div> -->

    <!-- 改版后的品牌展会 -->
    <!-- <div class="about-content" v-if="planName==='CMEF'">
      <img src="@assets/img/plan-cmef.png" />
      <p>
        CMEF（全称：中国国际医疗器械博览会）始创于1979年，展会历经40余年的积累和沉淀，现已发展成为亚太地区集医疗器械全产业链、集产品技术、新品首发、采购贸易、品牌传播、科研合作、学术论坛、教育培训为一体的医疗器械博览会，旨在助力医疗器械行业的健康快速发展。
        <br />
        <br />
        展会覆盖了医疗器械全产业链、集产品技术、新品首发、采购贸易、品牌传播、科研合作、学术论坛、教育培训，是国际领先的全球化综合服务平台。
      </p>
      <div style="position:relative;">
        <div class="content-btn" style="left:300px;" @click="cmefApply">申请展位</div>
        <div class="content-btn" style="left:460px;" @click="getTicket">获取门票</div>
      </div>
    </div>
    <div class="about-content" v-if="planName==='ICMD'">
      <img src="@assets/img/plan-icmd.png" />
      <p>
        ICMD（中国国际医疗器械设计与制造技术展览会）作为CMEF培育的子品牌，专注于医疗器械制造上游产业，是亚太地区覆盖医疗器械全产业链、集产品技术、服务创新与贸易、学术交流、教育与学习为一体的行业综合服务平台。
        <br />
        <br />
        CMEF与ICMD同期同地举行，着力于搭建医疗器械制造商与上游零配件、服务供应商的交流平台，展示医疗器械制造领域的最新科技，促进医疗器械整体产业链的互动。
      </p>
      <div style="position:relative;">
        <div class="content-btn" style="left:300px;" @click="icmdApply">申请展位</div>
        <div class="content-btn" style="left:460px;" @click="getTicket">获取门票</div>
      </div>
    </div>
    <div class="about-content" v-if="planName==='REHABSHOW'">
      <img src="@assets/img/plan-res.png" />
      <p>
        国际康复及个人健康博览会
        <br />
        <br />
        作为主办方历经7年积累和沉淀的品牌展会，国际康复及个人健康博览会已发展成为亚太地区专业康复医疗产品技术展览展示、新品首发、采购贸易、品牌传播、学术交流为一体综合服务平台，展会旨在为各医疗机构、康复中心、养老护理机构、药店及终端消费者等群体提供前沿康复技术及服务，助力全球康复医疗及个人健康产业实现跨越式发展。
        <br />
        <br />
        国际养老福祉及护理用品博览会
        <br />
        <br />
        国际养老福祉及护理用品博览会作为亚太地区优选，专注养老福祉、护理保健等领域政产学研用为一体的综合服务平台，致力汇聚全球各地养老福祉、护理保健、辅助器具、居家照护及生活文娱类产品新技术、新应用，助力养老行业全面打通医养结合、康养结合全产业链布局，同时助力中国养老行业的企业快速崛起。也为中国广大养老机构、康养中心等专业服务方提供专业的交流、合作、学习、供需对接平台。
      </p>
      <div style="position:relative;">
        <div class="content-btn" style="left:300px;" @click="resApply">申请展位</div>
        <div class="content-btn" style="left:460px;" @click="getTicket">获取门票</div>
      </div>
    </div> -->
    <!-- <div class="about-content" v-if="planName==='国际智慧健康'">
      <img src="@assets/img/plan-in.png" />
      <p>
        聚焦医疗领域智能技术的B2B及B2C企业，致力为国内外领先的智慧医疗企业提供智能科技成果发布、创新合作、产业聚集、商贸交流及学习体验等一站式综合服务平台，通过科技&智造的力量，推动行业向全球科技价值链中高端迈进。
        <br />
        <br />
        CMEF与ICMD、以及智慧健康展每年都会吸引数以万计的医院管理者、科研学术专家、行业经销商代理商及投融资机构等领域终端用户到会参观交流，采购下单。
        <br />
        <br />
        2019年智慧健康展已完成全面升级，面对消费升级、5G、医疗信息化&医疗大数据以及创新技术、健康产业的发展；同时为助力《健康中国2030》规划纲要中特别指出的推动健康科技创新、建设健康信息化服务体系目标。
        <br />
        <br />
        2020年智慧健康展将进行展位面积扩充，重点增加智慧医疗下的手术、物流、医疗服务机器人、5G技术应用、健康管理等领域，同时增加大数据应用下的疾病筛查、探讨增加大健康产业园区展示自己的技术孵化平台等服务。
      </p>
      <div style="position:relative;">
        <div class="content-btn" style="left:300px;" @click="inApply">申请展位</div>
        <div class="content-btn" style="left:460px;" @click="getTicket">获取门票</div>
      </div>
    </div> -->
    <div class="about-content" v-if="planInfo">
      <img v-if="planInfo && planInfo.banner" :src="planInfo.banner" />
      <img v-else src="@assets/img/empty.png" />
      <p>{{planInfo.description}}</p>
      <div style="position:relative;">
        <div class="content-btn" style="left:300px;" @click="inApply">申请展位</div>
        <div class="content-btn" style="left:460px;" @click="getTicket">获取门票</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "about",
  data() {
    return {
      planList: [],
      planInfo: null
    };
  },
  components: {
  },
  computed: {
    planId() {
      return this.$route.query.id;
    }
  },
  watch: {
    $route(val, oldVal) {
      this.init();
    }
  },
  methods: {
    ...mapActions({
      getPlanById: "getPlanById"
    }),
    async init() {
      let info = await this.getPlanById(this.planId);
      this.planInfo = info;
    },
    link(item) {
      if (item.link) {
        window.open(item.link,'_blank');
      }
    },
    getTicket() {
      if (this.planInfo.vLink) {
        window.open(this.planInfo.vLink,'_blank');
      }
    },
    inApply() {
      if (this.planInfo.exLink) {
        window.open(this.planInfo.exLink,'_blank');
      }
    }
  },
  created() {
    this.init();
  }
};
</script>

<style scoped lang='scss'>
.about {
  background-color: #fff;
  // padding: 20px;
  margin-bottom: 100px;
  &-list {
    width: 100%;
    height: 500px;
    padding: 20px 30px 20px 20px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    &:hover {
      cursor: pointer;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);
      h3 {
        color: #024c8b;
      }
    }
    img {
      width: 340px;
      height: 100%;
    }
    .list-text {
      width: calc(100% - 380px);
      height: 100%;
      display: flex;
      align-items: center;
      color: #333;
      div {
        width: 100%;
      }
      h3 {
        width: 100%;
        font-size: 16px;
        margin-bottom: 20px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
      p {
        font-size: 14px;
        line-height: 24px;
      }
      .t {
        width: 100%;
        margin-bottom: 20px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
    }
  }

  &-content {
    width: 900px;
    margin: 0 auto;
    padding: 100px 0;
    font-size: 0;
    img {
      width: 100%;
      height: 383px;
    }
    p {
      line-height: 30px;
      font-size: 16px;
      color: #333;
      margin-top: 25px;
      margin-bottom: 30px;
    }
    .content-btn {
      width: 120px;
      height: 35px;
      background-color: #024c8b;
      border-radius: 5px;
      font-size: 14px;
      color: #fff;
      text-align: center;
      line-height: 35px;
      position: absolute;
      top: 0;
      cursor: pointer;
    }
  }
}
</style>